import shipping1 from "../assets/images/shipping1.webp";
import shipping2 from "../assets/images/shipping2.webp";
import shipping3 from "../assets/images/shipping3.webp";
import shipping4 from "../assets/images/shipping4.webp";

const FooterQuickLinksData = [
    {
        id: 1,
        img: shipping1,
        title: "Free Shipping",
        description: "Free shipping on all India order"
    },
    {
        id: 2,
        img: shipping2,
        title: "Support 24/7",
        description: "Contact us 24 hours a day"
    },
    {
        id: 3,
        img: shipping3,
        title: "100% Money Back",
        description: "You have 30 days to Return"
    },
    {
        id: 4,
        img: shipping4,
        title: "Payment Secure",
        description: "We ensure secure payment"
    },
];

export default FooterQuickLinksData;